
import { getOrderProcess, configOrderProcess } from '@/api/templateEvaluate';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import { saveOrderPollingDiyData } from '../../api/system';
import OrderProcess from './components/systemProcess.vue';

@Component({
  name: 'SettingOrderPolling',
  components: {
    OrderProcess
  }
})
export default class extends Vue {
  private activeName = 'first'
  private listData: any = { // 此处重点学习 如果不初始Key 组件接收数据为空
    process: {},
    module: [],
    moduleAuth: {},
    moduleAlias: {}
  }
  private selectedData: any = {}
  private loading = true

  private settingForm: any = {
    picture: ''
  }

  // life circle
  private created() {
    if (UserModule.getCompany && parseInt((UserModule.getCompany as any).is_order_polling_chooseimg) === 1) {
      this.settingForm.picture = true;
    } else {
      this.settingForm.picture = false;
    }
    this.getOrderProcess();
  }
  private selectChange() {
    let paramters:any = {};
    paramters.user_id = UserModule.getUserId;
    paramters.company_id = UserModule.getCompanyId;
    if (this.settingForm.picture) {
      paramters.is_order_polling_chooseimg = 1;
    } else {
      paramters.is_order_polling_chooseimg = 0;
    }
    saveOrderPollingDiyData(paramters).then(res => {
      this.showSuccessMsg('修改成功');
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  private getOrderProcess() {
    let params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId
    };
    getOrderProcess(params).then(res => {
      this.loading = false;
      const data = res.data;
      if (data) {
        this.listData.process = data.level.check_module.auth;
        this.listData.module = data.level.check_module.module;
        this.listData.moduleAuth = data.level.check_module.module_auth;
        this.listData.moduleAlias = data.module_alias;
        this.listData.authConfig = data.auth_config;
        this.selectedData = data.check;
      }
    }).catch(err => {
      this.loading = false;
      this.showErrorMsg(err.msg);
    });
  }

  // hud
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
